import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import ActionButtons from "../components/ActionButtons";
import Header from "../components/Header";
import Loader from "../components/Loader";
import { fields, LOCAL_STORAGE_KEY } from "../constants";
import { getDetailsApi } from "../utils/api";
import { mergeLookupDetails } from "../utils/lookupDetails";

const Odisha = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "null");

  const state = "odisha";
  const history = useHistory();

  // all input fields
  const [payLoad, setPayLoad] = useState({
    vehicleNo: "",
    chassisNo: "",
    mobileNo: "",
    vehiclePermitType: "",
    seatingCapacityExcludingDriver: "",
    sleeperCapacityExcludingDriver: "",
    borderBarrier: "",
    totalAmount: "",
    ownerName: "",
    fromState: "",
    vehicleClass: "",
    taxMode: "",
    taxFromDate: "",
    taxUptoDate: "",
    permitType: "",
    serviceType: "",
    grossVehicleWeight: "",
    unladenWeight: "",
    basicPermitValidity: "", // Maps to Permit Validity
    fitnessValidity: "",
    insuranceValidity: "",
    taxValidity: "",
    roadTaxValidity: "",
    floorArea: "",
    applicationFee: "",
    mvTax: "",
    permitFee: "",
    enteringDistrict: "",
    entryCheckPostName: "",
    vehicleCategory: "",
    // --- Newly Added Fields for Odisha Receipt ---
    paymentDate: "",        // Payment Initialization Date
    bankRefNo: "",          // Bank Reference Number
    paymentMode: "",  // Default payment mode
    puccValidity: "",       // PUCC Validity
    paymentConfirmationDate: "", // Payment Confirmation Date
    permitValidity: "",
  });

 const [isLoading, setIsLoading] = useState(false);

  const form = useRef(null);
  const odishaDistricts = [
    "BARGARH",
    "KENDRAPARA",
    "JAGATSINGHAPUR",
    "CUTTACK",
    "JAJAPUR",
    "DHENKANAL",
    "ANUGUL",
    "NAYAGARH",
    "KHORDHA",
    "PURI",
    "GANJAM",
    "JHARSUGUDA",
    "GAJAPATI",
    "KANDHAMAL",
    "BAUDH",
    "SUBARNAPUR",
    "BALANGIR",
    "NUAPADA",
    "KALAHANDI",
    "RAYAGADA",
    "NABARANGAPUR",
    "KORAPUT",
    "SAMBALPUR",
    "MALKANGIRI",
    "DEBAGARH",
    "SUNDARGARH",
    "KENDUJHAR",
    "MAYURBHANJ",
    "BALESHWAR",
    "BHADRAK",
  ];
  const vehiclePermitTypeOptions = ["TRANSPORT", "NON-TRANSPORT"];
  const transportClassOptions = [
    "THREE WHEELER (PASSENGER)",
    "MAXI CAB",
    "MOTOR CAB",
    "BUS",
    "OMNI BUS",
    "GOODS CARRIER",
    "ARTICULATED VEHICLE",
    "EDUCATIONAL INSTITUTION BUS",
    "TRACTOR (COMMERCIAL)",
    "PRIVATE SERVICE VEHICLE",
    "TRAILER (COMMERCIAL)",
    "TRACTOR-TROLLEY(COMMERCIAL)",
    "SEMI-TRAILER (COMMERCIAL)",
  ];

  const nonTransportClassOptions = [
    "CONSTRUCTION EQUIPMENT VEHICLE",
    "MOTOR CYCLE/SCOOTER",
    "MOTOR CAR",
    "AGRICULTURAL TRACTOR",
    "HARVESTER",
    "TRAILER (AGRICULTURAL)",
    "TRAILER FOR PERSONAL USE",
  ];

  const passengerClasses = [
    "THREE WHEELER (PASSENGER)",
    "MAXI CAB",
    "MOTOR CAB",
    "BUS",
    "OMNI BUS",
    "EDUCATIONAL INSTITUTION BUS",
    "PRIVATE SERVICE VEHICLE",
  ];

  const getDetailsHandler = async () => {
    if (!payLoad.vehicleNo) {
      alert("Please enter vehicle no.");
      return;
    }
    setIsLoading(true);
    const { data } = await getDetailsApi({
      vehicleNo: payLoad.vehicleNo,
    });
    setIsLoading(false);
    if (data && data.success) {
setPayLoad((e) => ({
        ...e,
        ...mergeLookupDetails(e, data.detail),
      }));
    }
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!payLoad.unladenWeight) {
      payLoad.unladenWeight = 0;
    }

    if (
      (payLoad.vehiclePermitType === "CONSTRUCTION EQUIPMENT VEHICLE" &&
        payLoad.permitType === "NOT APPLICABLE") ||
      (payLoad.vehiclePermitType === "CONTRACT CARRIAGE/PASSANGER VEHICLES" &&
        payLoad.permitType === "TOURIST PERMIT") ||
      (payLoad.vehiclePermitType === "GOODS VEHICLE" &&
        payLoad.permitType === "NATIONAL PERMIT")
    ) {
      payLoad.totalAmount = +payLoad.mvTax +
        +payLoad.permitFee +
        +payLoad.applicationFee;
    } else {
      payLoad.totalAmount =
        +payLoad.mvTax +
        +payLoad.permitFee +
        +payLoad.applicationFee;
    }

    history.push("/select-payment", {
      formData: {
        ...payLoad,
        state,
      },
    });
  };

const onChangeHandler = (e) => {
  const { name, value } = e.target;
  if (name === "vehiclePermitType") {
    setPayLoad((old) => ({
      ...old,
      vehiclePermitType: value,
      vehicleClass: "",
    }));
  } else {
    setPayLoad((old) => ({
      ...old,
      [name]: value,
    }));
  }
};

  const onResetHandler = () => {
    let x = { ...payLoad };
    let p = {};
    Object.keys(x).forEach((e) => {
      p[e] = "";
    });
    setPayLoad({ ...p });
  };

  if (!isLoggedIn || !isLoggedIn.accessState || !isLoggedIn.accessState.includes(fields.stateName.odisha)) {
    return (
      <>
        <Header />
        <div className="container text-center mt-4 ">
          <h3>No Access of this state</h3>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="text-center">
        <p className="login-heading mt-4">
          <b>BORDER TAX PAYMENT FOR ENTRY INTO</b> <span>ODISHA</span>
        </p>
      </div>
      <div className="box box--main">
        <div className="box__heading--blue">Tax Payment Details</div>
        <form
          ref={form}
          onSubmit={onSubmitHandler}
          className="service-type tax-details mt-4"
        >
          <div className="row">
            <div className="col-6">
              {/* <!-- vehicle number --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="vehicleNo"
                >
                  Vehicle No.<sup>*</sup>
                </label>
                <input
                  tabIndex="1"
                  required
                  maxLength="10"
                  autoFocus
                  inputMode="text"
                  disabled={isLoading}
                  value={payLoad.vehicleNo}
                  onChange={onChangeHandler}
                  className="form__input w-100"
                  type="text"
                  id="vehicleNo"
                  name="vehicleNo"
                />
              </div>
              
              {/* <!-- chassis number --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="chassisNo"
                >
                  Chassis No.<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="2"
                  maxLength="19"
                  inputMode="text"
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.chassisNo}
                  className="form__input w-100"
                  type="text"
                  id="chassisNo"
                  name="chassisNo"
                />
              </div>
              {/* <!-- mobile number --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="mobileNo"
                >
                  Mobile No.<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="3"
                  disabled={isLoading}
                  value={payLoad.mobileNo}
                  onChange={onChangeHandler}
                  placeholder="SMS about payment will be sent to this number "
                  className="form__input w-100"
                  type="text"
                  id="mobileNo"
                  inputMode="tel"
                  maxLength="10"
                  minLength="10"
                  name="mobileNo"
                />
              </div>
              <div className="row">
                {/* <!-- vehicle type --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehiclePermitType"
                    >
                      Vehicle Type<sup>*</sup>
                    </label>
                    <select
                      tabIndex="4"
                      value={payLoad.vehiclePermitType}
                      onChange={onChangeHandler}
                      required
                      name="vehiclePermitType"
                      id="vehiclePermitType"
                    >
                      <option value="">Select Vehicle Type...</option>
                      {vehiclePermitTypeOptions.map((name) => {
                        return (
                          <option value={name} key={name}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {/* <!-- vehicle className --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehicleClass"
                    >
                      Vehicle Class<sup>*</sup>
                    </label>
                    <select
                      tabIndex="11"
                      required
                      disabled={isLoading}
                      value={payLoad.vehicleClass}
                      onChange={onChangeHandler}
                      name="vehicleClass"
                      id="vehicleClass"
                    >
                      <option value="">Select Vehicle Class...</option>
                      {payLoad.vehiclePermitType === "TRANSPORT" &&
                        transportClassOptions.map((name) => (
                          <option value={name} key={name}>
                            {name}
                          </option>
                        ))}
                      {payLoad.vehiclePermitType === "NON-TRANSPORT" &&
                        nonTransportClassOptions.map((name) => (
                          <option value={name} key={name}>
                            {name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              {passengerClasses.includes(payLoad.vehicleClass) ? (
                <div className="row">
                  {/* <!-- seating capacity --> */}
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="seatingCapacityExcludingDriver"
                      >
                        Seating Capacity(Ex. Driver)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.seatingCapacityExcludingDriver}
                        id="seatingCapacityExcludingDriver"
                        name="seatingCapacityExcludingDriver"
                      />
                    </div>
                  </div>

                  {/* <!-- sleeper capacity  --> */}
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="sleeperCapacityExcludingDriver"
                      >
                        Sleeper Capacity <sup>*</sup>
                      </label>
                      <input
                        tabIndex="6"
                        required
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        value={payLoad.sleeperCapacityExcludingDriver}
                        className="form__input w-100"
                        type="number"
                        id="sleeperCapacityExcludingDriver"
                        name="sleeperCapacityExcludingDriver"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  {/* <!-- gross vehicle weight --> */}
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="grossVehicleWeight"
                      >
                        Gross Vehicle Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.grossVehicleWeight}
                        id="grossVehicleWeight"
                        name="grossVehicleWeight"
                      />
                    </div>
                  </div>
                  {/* <!-- un laden weight --> */}
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="unladenWeight"
                      >
                        Unladen Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.unladenWeight}
                        id="unladenWeight"
                        name="unladenWeight"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-sm-6">
                  {/* <!-- Insurance Validity --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="insuranceValidity"
                    >
                      Insurance Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="insuranceValidity"
                      name="insuranceValidity"
                      onChange={onChangeHandler}
                      value={payLoad.insuranceValidity}
                    />
                  </div>
                </div>
                {/* <!-- Road Tax Validity --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="roadTaxValidity"
                    >
                      Road Tax Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="roadTaxValidity"
                      name="roadTaxValidity"
                      type="datetime-local"
                      value={payLoad.roadTaxValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <!-- Fitness Validity --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="fitnessValidity"
                    >
                      Fitness Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="fitnessValidity"
                      name="fitnessValidity"
                      type="datetime-local"
                      value={payLoad.fitnessValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
                {/* <!-- PUCC Validity (replaces Tax Mode) --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="puccValidity"
                    >
                      PUCC Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="7"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="puccValidity"
                      name="puccValidity"
                      type="datetime-local"
                      value={payLoad.puccValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
              {/* <!-- Tax From Date (moved to left column) --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="taxFromDate"
                >
                  Tax From Date<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="15"
                  disabled={isLoading}
                  className="form__input w-100"
                  type="datetime-local"
                  id="taxFromDate"
                  name="taxFromDate"
                  onChange={onChangeHandler}
                  value={payLoad.taxFromDate}
                />
              </div>
            </div>
            {/* =========================== right side fields ============================ */}
            <div className="col-6">
              <div className="form__control text-left">
                <label className="form__label d-block w-100 text-left">
                  &nbsp;
                </label>
                {isLoading && <Loader className="loader__get-details" />}
                {!isLoading && (
                  <button
                    disabled={isLoading}
                    type="button"
                    onClick={getDetailsHandler}
                    className="box__button get-details"
                  >
                    <span className="glyphicon glyphicon-arrow-down mr-3"></span>
                    Get Details
                  </button>
                )}
              </div>
              {/* <!-- owner name --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="ownerName"
                >
                  Owner Name<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="9"
                  disabled={isLoading}
                  className="form__input w-100"
                  type="text"
                  id="ownerName"
                  inputMode="text"
                  name="ownerName"
                  onChange={onChangeHandler}
                  value={payLoad.ownerName}
                />
              </div>
              {/* <!-- from state --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="fromState"
                >
                  From State<sup>*</sup>
                </label>
<select
                  tabIndex="10"
                  disabled={isLoading}
                  required
                  value={payLoad.fromState}
                  onChange={onChangeHandler}
                  name="fromState"
                  id="fromState"
                >
                  <option value="">--Select State--</option>
                  {fields.fromState.map((type) => {
                    return (
                      <option key={type.name} value={String(type.name).toUpperCase()}>
                        {type.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehicleCategory"
                    >
                      Vehicle Category<sup>*</sup>
                    </label>
                    <select
                      tabIndex="12"
                      required
                      disabled={isLoading || !payLoad.vehicleClass}
                      value={payLoad.vehicleCategory}
                      onChange={onChangeHandler}
                      name="vehicleCategory"
                      id="vehicleCategory"
                    >
                      <option value="">--Select Vehicle Category--</option>
                      {passengerClasses.includes(payLoad.vehicleClass) ? (
                        <>
                          <option value="LIGHT PASSENGER VEHICLE">LIGHT PASSENGER VEHICLE</option>
                          <option value="MEDIUM PASSENGER VEHICLE">MEDIUM PASSENGER VEHICLE</option>
                          <option value="HEAVY PASSENGER VEHICLE">HEAVY PASSENGER VEHICLE</option>
                        </>
                      ) : (
                        <>
                          <option value="LIGHT GOODS VEHICLE">LIGHT GOODS VEHICLE</option>
                          <option value="MEDIUM GOODS VEHICLE">MEDIUM GOODS VEHICLE</option>
                          <option value="HEAVY GOODS VEHICLE">HEAVY GOODS VEHICLE</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>
                {/* <!-- permit type --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="permitType"
                    >
                      Permit Type<sup>*</sup>
                    </label>
                    <select
                      required
                      tabIndex="12"
                      disabled={isLoading}
                      value={payLoad.permitType}
                      onChange={onChangeHandler}
                      name="permitType"
                      id="permitType"
                    >
                      <option value="">--Select Permit Type--</option>
                      {fields.odisha.permitType.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="serviceType"
                    >
                      Service type<sup>*</sup>
                    </label>
                    <select
                      required
                      tabIndex="11"
                      disabled={isLoading}
                      name="serviceType"
                      id="serviceType"
                      value={payLoad.serviceType}
                      onChange={onChangeHandler}
                    >
                      <option value="">--Select Service Type--</option>
                      {fields.odisha.serviceType.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  {/* <!-- Permit validity --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="permitValidity"
                    >
                      Permit validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="permitValidity"
                      name="permitValidity"
                      onChange={onChangeHandler}
                      value={payLoad.permitValidity}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="enteringDistrict"
                    >
                      Entry District Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex="13"
                      required
                      disabled={isLoading}
                      value={payLoad.enteringDistrict}
                      onChange={onChangeHandler}
                      name="enteringDistrict"
                      id="enteringDistrict"
                    >
                      <option value="">Select District Name...</option>
                      {odishaDistricts.map((name) => {
                        return (
                          <option key={name} value={name}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="entryCheckPostName"
                    >
                      CheckPost Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex="13"
                      required
                      disabled={isLoading}
                      value={payLoad.entryCheckPostName}
                      onChange={onChangeHandler}
                      name="entryCheckPostName"
                      id="entryCheckPostName"
                    >
                      <option value="">Select CheckPost Name...</option>
                      {odishaDistricts.map((name) => {
                        return (
                          <option key={name} value={name}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>

              {/* <!-- Tax Mode full width in right column --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="taxMode"
                >
                  Tax Mode<sup>*</sup>
                </label>
                <select
                  tabIndex="14"
                  required
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.taxMode}
                  name="taxMode"
                  id="taxMode"
                >
                  <option value="">--Select Tax Mode--</option>
                  {fields?.odisha?.taxMode.map((type) => {
                    return (
                      <option value={type.name} key={type.name}>
                        {type.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* <!-- Tax Upto Date (moved to right column, full width) --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="taxUptoDate"
                >
                  Tax Upto Date<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="16"
                  disabled={isLoading}
                  className="form__input w-100"
                  id="taxUptoDate"
                  name="taxUptoDate"
                  type="datetime-local"
                  value={payLoad.taxUptoDate}
                  onChange={onChangeHandler}
                />
              </div>
 
              
            </div>
          </div>
          {/* =============== table ======================== */}
          <div className="row mt-3">
            <div className="col-12">
              <table className="hr-table">
                <thead>
                  <tr>
                    <th className="hr-table-1">SI. No.</th>
                    <th className="hr-table-2">Particulars</th>
                    <th>Tax From</th>
                    <th>Tax Upto</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="">1</td>
                    <td className="pb-table-text">MV Tax</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          disabled={isLoading}
                          value={payLoad.mvTax}
                          onChange={onChangeHandler}
                          name="mvTax"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td className="">3</td>
                    <td className="pb-table-text">Application Fee</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          disabled={isLoading}
                          value={payLoad.applicationFee}
                          onChange={onChangeHandler}
                          name="applicationFee"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>

                  {(payLoad.vehiclePermitType ===
                    "CONSTRUCTION EQUIPMENT VEHICLE" &&
                    payLoad.permitType === "NOT APPLICABLE") ||
                    (payLoad.vehiclePermitType ===
                    "CONTRACT CARRIAGE/PASSANGER VEHICLES" &&
                      payLoad.permitType === "TOURIST PERMIT") ||
                    (payLoad.vehiclePermitType === "GOODS VEHICLE" &&
                      payLoad.permitType === "NATIONAL PERMIT") ? (
                    <></>
                  ) : (
                    <>
                      <tr>
                        <td className="">4</td>
                        <td className="pb-table-text">Permit Fee</td>
                        <td className=""></td>
                        <td className=""></td>
                        <td className="input-box">
                          <center>
                            <input
                              tabIndex="17"
                              disabled={isLoading}
                              value={payLoad.permitFee}
                              onChange={onChangeHandler}
                              name="permitFee"
                              type="number"
                              min="0"
                              inputMode="numeric"
                            />
                          </center>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-6">
              {/* <!-- Total amount --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="totalAmount"
                >
                  Total amount<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="18"
                  min="0"
                  disabled
                  value={
                    (payLoad.vehiclePermitType ===
                      "CONSTRUCTION EQUIPMENT VEHICLE" &&
                      payLoad.permitType === "NOT APPLICABLE") ||
                      (payLoad.vehiclePermitType ===
                      "CONTRACT CARRIAGE/PASSANGER VEHICLES" &&
                        payLoad.permitType === "TOURIST PERMIT") ||
                      (payLoad.vehiclePermitType === "GOODS VEHICLE" &&
                        payLoad.permitType === "NATIONAL PERMIT")
                      ? +payLoad.mvTax + +payLoad.applicationFee + +payLoad.permitFee
                      : +payLoad.mvTax + +payLoad.applicationFee + +payLoad.permitFee
                  }
                  className="form__input w-100"
                  type="number"
                  id="totalAmount"
                  name="totalAmount"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <label className="form__label d-block w-100 text-left">
                &nbsp;
              </label>
              <ActionButtons
                tabIndex="19"
                isDisabled={isLoading}
                onReset={onResetHandler}
              />
            </div>
          </div>
        </form>
        <br />
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Odisha;
